export default __webpack_public_path__ + "static/media/flyer.f8b7842a.svg";